// src/helpers/cognitoLogin.js  (o donde lo tengas)
export async function cognitoLogin(username, password) {
  const region = process.env.REACT_APP_COGNITO_REGION;
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;

  if (!region || !clientId) {
    throw new Error("Falta REACT_APP_COGNITO_REGION o REACT_APP_COGNITO_CLIENT_ID en .env");
  }

  const res = await fetch(`https://cognito-idp.${region}.amazonaws.com/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
    },
    body: JSON.stringify({
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: clientId,
      AuthParameters: {
        USERNAME: username,
        PASSWORD: password,
      },
    }),
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data?.message || "Error en login Cognito");
  }

  const idToken = data?.AuthenticationResult?.IdToken || "";
  const accessToken = data?.AuthenticationResult?.AccessToken || "";
  const refreshToken = data?.AuthenticationResult?.RefreshToken || "";
  const expiresIn = data?.AuthenticationResult?.ExpiresIn || 0;

  if (!accessToken) throw new Error("Login OK pero no llegó AccessToken (necesario para el Authorizer)");
  if (!idToken) throw new Error("Login OK pero no llegó IdToken");

  // ✅ Guardar tokens
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("idToken", idToken);
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
  if (expiresIn) localStorage.setItem("expiresIn", String(expiresIn));
  localStorage.setItem("tokenSavedAt", String(Date.now()));
  localStorage.setItem("ipdepot:refreshSource", "direct");

  if (data?.AuthenticationResult?.NewDeviceMetadata?.DeviceKey) {
    localStorage.setItem(
      "ipdepot:deviceKey",
      data.AuthenticationResult.NewDeviceMetadata.DeviceKey
    );
  }

  return { idToken, accessToken, refreshToken, expiresIn, raw: data };
}
